import '../scss/groupe.scss';
import Common from './common.js';
import $ from "jquery";
import Swiper from "swiper";
import Sliders from "./sliders";
import './jquery.matchHeight-min';
import Forms from "./forms";

// Case Insensitive Contains declaration
jQuery.expr[':'].Contains = function(a, i, m) {
    return jQuery(a).text().toUpperCase()
        .indexOf(m[3].toUpperCase()) >= 0;
};

let toggleTilesState = function () {
    $('.js-toggleSearch').on('click', function (e) {
        e.stopPropagation();
        if (!$(e.target).is("input") && !$(e.target).is("button")) {
            $('.project__filter').toggleClass('search-expanded');
            let isExapended = $(e.target).attr("aria-expanded") !== "true";
            $(e.target).attr("aria-expanded", isExapended);
        }
    });

    $('.js-reset-input').on('click', function(e) {
        e.preventDefault();
        let target = $(this).attr('data-target');
        $(target).val('');
        e.stopPropagation();
    });
};

let initFilter = function() {
    let sliderDate = $('.swiper-container.-projects');
    let sliderTheme = $('.swiper-container.-theme');

    let query = $('#filterSearch-projects').val();

    if(sliderDate.length) {
        // needs to be destroyed and reinit to show correctly the filtered slides
        $('.swiper-container').each(function () {
            if (this.swiper) {
                this.swiper.destroy(true, true);
            }
        });
        Sliders.sliders = [];
        filterProjects(sliderDate, query);
    }

    if(sliderTheme.length) {
        filterThemeProjects(sliderTheme, query);
    }
};

let filterProjects = function (slider, query) {
    let projectFilter = $('.projects__filter-container');
    let $activeFilters = projectFilter.find('.js-filterProject:checked');
    let $projectSlides = $('.swiper-container.-projects .js-project-slide');
    let isProjects = true;

    let searchedSlides = $projectSlides.filter(function() {
        let title = $(this).find(".project__title:Contains('" + query + "')");
        let infos = $(this).find(".project__infos:Contains('" + query + "')");
        let regex = new RegExp(query);
        let hasClass = regex.test($(this).attr('class'));

        if(title.length | infos.length | hasClass) {
            return $(this);
        }
    });

    $projectSlides.addClass("non-swiper-slide").removeClass("swiper-slide").hide();

    if ($activeFilters.length > 0) {

        let selector = '';

        $activeFilters.each(function () {
            selector += '.' +  this.getAttribute('data-filter');
        });

        if ('' !== selector) {
            searchedSlides
                .filter(selector)
                .removeClass("non-swiper-slide")
                .addClass("swiper-slide")
                .attr("style", null)
                .show()
            ;
        }
    } else {
        searchedSlides
            .removeClass("non-swiper-slide")
            .addClass('swiper-slide')
            .show()
        ;

        isProjects = true;
        $('.projects__error').hide();
        $('.filtered-slider').show();
    }

    $('.filtered-slider').each(function() {
        $projectSlides = $(this).find('.js-project-slide');
        let errorMessage = $(this).closest('.tab-pane').find('.projects__error');

        if($projectSlides.filter('.swiper-slide').length) {
            isProjects = true;
            errorMessage.hide();
            $(this).show();
        } else {
            isProjects = false;
            errorMessage.css("display", "flex");
            $(this).hide();
        }
    });

    if ($(window).innerWidth() >= Common.mqBreakpoints.md && isProjects) {
        slider.each(function () {
            let slidesCount = this.querySelectorAll('.swiper-slide').length;

            let swiper = new Swiper(this, {
                speed: 400,
                spaceBetween: 100,
                loop: slidesCount > 1,
                watchOverflow: true,
                navigation: {
                    prevEl: '.swiper-button-prev',
                    nextEl: '.swiper-button-next'
                },
                loopAdditionalSlides: 2,
                on: {
                    init: function () {
                        Sliders.setGridSize(this);
                    },
                }
            });

            if (slidesCount <= 1) {
                swiper.navigation.prevEl && swiper.navigation.prevEl.classList.add('d-none');
                swiper.navigation.nextEl && swiper.navigation.nextEl.classList.add('d-none');
            }
        });
    }
};

let filterThemeProjects = function() {
    let projectFilter = $('.projects__filter-container');
    let $activeFilters = projectFilter.find('.js-filterProject:checked');
    let $projectSection= $('.js-project-category');
    let errorMessage = $('#theme-pane .projects__error');
    let $projectSlides = $('.swiper-container.-theme .js-project-slide');

    if ($activeFilters.length > 0) {
        let selector = '';
        $projectSlides.addClass("non-swiper-slide").removeClass("swiper-slide").hide();

        $activeFilters.each(function () {
            selector += '.' +  this.getAttribute('data-filter');
        });

        if ('' !== selector) {
            $projectSlides
                .filter(selector)
                .removeClass("non-swiper-slide")
                .addClass("swiper-slide")
                .attr("style", null)
                .show()
            ;
        }

        if( $('.jumbotron.-projects:visible').length > 0) {
            $('.jumbotron.-projects').css('display','flex').fadeOut("fast");
        }
        $('.swiper-container.-theme').each(function() {
            if ($(this).find('.swiper-slide').length > 0) {
                $(this).closest('.js-project-category').show();
            } else {
                $(this).closest('.js-project-category').hide();
            }
        });

        if($projectSection.filter('.project__category:visible').length) {
            errorMessage.hide();
        } else {
            errorMessage.css("display", "flex");
        }
    } else {
        errorMessage.hide();
        $('.js-project-category').show();

        $projectSlides
            .removeClass("non-swiper-slide")
            .addClass('swiper-slide')
            .show()
        ;

        if($(window).innerWidth() >= Common.mqBreakpoints.md) {
            $('.jumbotron.-projects').fadeIn("fast");
        } else {
            $('.jumbotron.-projects').fadeOut("fast");
        }
    }
    Sliders.initNormalSlider();

};
let filterBySearch = function() {
    let self = this;

    $('#filterSearch-projects').on('keydown', function() {
        let filterQuary = Common.debounce(function () {
            initFilter();
        }, 250);

        filterQuary();
    });
};

let showDateFilterBtn = function () {
    let isNotOnDesktop = $(window).innerWidth() < Common.mqBreakpoints.lg;

    if ($('.projects__burger').length && ($('#date-pane.active.show').length || $('#theme-pane.active.show').length) && isNotOnDesktop) {
        $('.projects__burger').show();
    } else if ($('.projects__burger').length) {
        $('.projects__burger').hide();
    }
};

let organisationServicesHandler = function() {
    // https://github.com/liabru/jquery-match-height/issues/104
    // $('[data-mh="organisation-service-title"]').matchHeight({ property: 'min-height' });
    $('.js-organisation-service-title').matchHeight({ property: 'min-height' });
    $('.js-organisation-service').matchHeight({ property: 'min-height' });

    organisationServiceResizeHandler();

    $('#organisationServices')
        .on('show.bs.collapse', function(e) {
            if ($(window).innerWidth() >= Common.mqBreakpoints.md) {
                centerOrganisationChart($(e.target));
            }
        })
        .on('shown.bs.collapse', function (e) {
            organisationChartHeightHandler($(e.target));
            if ($(window).innerWidth() >= Common.mqBreakpoints.md) {
                centerOrganisationChart($(e.target));
            }
        })
        .on('hide.bs.collapse', function(e) {
            if ($(window).innerWidth() >= Common.mqBreakpoints.md) {
            }
        })
        .on('hidden.bs.collapse', function(e) {
            if ($(window).innerWidth() >= Common.mqBreakpoints.md) {
                let $target = $(e.target);
                $target.closest('.organisation-chart__leaf').css('margin-bottom', '');
                $target.css('left', 'auto');
            }
        })
    ;
};

let organisationChartHeightHandler = function(target) {
    let leaf =  target.closest('.organisation-chart__leaf');
    if ($(window).innerWidth() >= Common.mqBreakpoints.md) {
        leaf.css('margin-bottom', target.outerHeight() + 'px');
    } else {
        leaf.css('margin-bottom', 0);
    }
};

let centerOrganisationChart = function(target) {
    let organisationChartOffestLeft = target.closest('.organisation-chart').offset().left;
    let LeaftOffestLeft = target.closest('.organisation-chart__leaf').offset().left;
    target.css('left', (organisationChartOffestLeft - LeaftOffestLeft) + 'px');
};

let organisationServiceResizeHandler= function () {
    let openedServiceChart = $('.organisation-service.show');
    if(openedServiceChart.length) {
        organisationChartHeightHandler(openedServiceChart);
        centerOrganisationChart(openedServiceChart);
    }
};


$(window).resize(function (e) {
    // initFilter();
    showDateFilterBtn();
    organisationServiceResizeHandler();
});

$(document).ready(function () {
    toggleTilesState();
    initFilter();
    organisationServicesHandler();

    $('.js-filterProject').on('change', initFilter);

    $('.projects__nav .nav-link').on('shown.bs.tab', function (e) {
        showDateFilterBtn();
        initFilter();
    });

    $('.projects__overview .nav-link').on('shown.bs.tab', function (e) {
        initFilter();
    });

    showDateFilterBtn();
    filterBySearch();

    Sliders.initNoOverflowSlide();
    Forms.initForm();
});